//
// Constants - All API Hosts and Routes
//
export const APIVars = Object.freeze({
    AppEnvironment: process.env.VUE_APP_APPENV,
    BaseUrl: process.env.VUE_APP_BASE_API_URL, //PROD
    AppVersionString: process.env.VUE_APP_VER + '.' + process.env.VUE_APP_REV + (process.env.VUE_APP_SPECIAL != '' ? ' - ' + process.env.VUE_APP_SPECIAL : ''),
    AlertBaseUrl: process.env.VUE_APP_ALERT_BASE_URL,
    CreateForm14Route: '/api/utils/createForm14',
    GetTopLevelGroupsRoute: '/api/utils/getTopLevelGroups',
    GetUnitsForTopLevelGroupRoute: '/api/utils/getUnitsForTopLevelGroup',
    GetDutyPositionsForUnitRoute: '/api/utils/getDutyPositionsForUnit',
    GetStaffForUnitDutyPositionRoute: '/api/utils/getStaffForUnitDutyPosition',
    GetRatingsWithSetsRoute: '/api/utils/getRatingsWithSets',
    GetSetsByRatingRoute: '/api/utils/getSetsByRating',
    GetSetsByUnitRoute: '/api/utils/getSetsByUnit',
    GetSpecTracksRoute: '/api/utils/getSpecTracks',
    GetSpecTracksByMemberRoute: '/api/utils/getSpecTracksByMember',
    GetSpecTracksByTrackRoute: '/api/utils/getSpecTracksByTrack',
    GetSpecTracksByUnitRoute: '/api/utils/getSpecTracksByUnit',
    GetICListRoute: '/api/utils/getICListMobile',
    GetICZonesOrTypesRoute: '/api/utils/getICZonesOrTypes',
    GetAircraftListRoute: '/api/aircraft/getAircraftList',
    GetFROListRoute: '/api/FlightReleaseOfficer/getFROList',
    GetFROListGroupsRoute: '/api/FlightReleaseOfficer/getFROListGroups',
    GetCheckPilotTypesRoute: '/api/checkpilot/getCheckPilotTypes',
    GetCheckPilotListRoute: '/api/checkpilot/getCheckPilotList',
    GetCheckPilotUnitsRoute: '/api/checkpilot/getCheckPilotUnits',
    GetMemberInfoUpnRoute: '/api/members/getMemberInfoUpn',
    GetMemberInfoCapidRoute: '/api/members/getMemberInfoCapid',
    GetMemberInfoLastNameRoute: '/api/members/getMemberInfoLastName',
    GetMemberSkillsRoute: '/api/members/getMemberSkills',
    GetCapidFromUpnRoute: '/api/members/getCapidFromUpn',
    GetToldDataRoute: '/api/utils/gettoldData',
    GetAirportListRoute: '/api/utils/getAirportList',
    GetCallsignListRoute: '/api/callsign/getCallsignList',
    UpdateCovidStatsRoute: "/api/covid/updateCovidStats",
    GetCovidStatsRoute: "/api/covid/getCovidStats",
    GetCovidChartDataRoute: "/api/covid/getCovidChartData",
    GetCurrentWMAORecordRoute: "/api/wmao/lookupCurrentWMAORecord",
    getPreviousWMAORecordRoute: "/api/wmao/lookupPreviousWMAORecord",
    GetWMAOCoordinatorsbyCapidRoute: "/api/wmao/getWMAOCoordinatorsbyCapid",
    SetCurrentWMAORoute: "/api/wmao/upsertWMAORecord",
    GetPhoneNumbersforMemberRoute: '/api/users/getMemberPhoneNumbers',
    AlertICWMAORoute: '/callsystem/wmaocall/initiatewmaocall',
    GetCellTrackingMissions: '/api/tracs/getActiveCellTrackingMissions',
    GetCellTrackingSorties: '/api/tracs/getActiveCellTrackingSorties',
    UpsertCellTrackingEvent: '/api/tracs/upsertCellTrackingEvent',
    InsertO365LicenseRequest: '/api/utils/insertO365LicenseRequest',
    config: {
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': '9YADUwshAl48ljYiaT4rv8nGIWipkG734cDEE2yQ'
      }
    },
    alertconfig: {
      'Content-Type': 'application/json',
      'x-api-key': 'f50dcb8b-7299-4d4c-be86-dbc21181b3d2'
    },
    appColor:"blue darken-4",
    appTitle:"PCR Mobile Assistant"
  });
